import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";
import { CommonDialog, DIALOG_TYPES } from "./CommonDialog";

const DialogContext = createContext();

const defaultDialogState = {
  isOpen: false,
  type: DIALOG_TYPES.INFO,
  title: "",
  message: "",
  buttonText: "OK",
  cancelText: "Cancel",
  onConfirm: null,
  disableEscapeKeyDown: false,
};

export const DialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState(defaultDialogState);

  const showDialog = useCallback((options) => {
    setDialogState({
      ...defaultDialogState,
      ...options,
      isOpen: true,
    });
  }, []);

  const closeDialog = useCallback(() => {
    setDialogState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const contextValue = useMemo(
    () => ({ showDialog, closeDialog }),
    [showDialog, closeDialog]
  );

  return (
    <DialogContext.Provider value={contextValue}>
      {children}
      <CommonDialog dialog={dialogState} onClose={closeDialog} />
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context)
    throw new Error("useDialog must be used within a DialogProvider");
  return context;
};
